import { ChangeDetectorRef, Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { LoggerService } from '../../core/services/logger.service';
import { ProfileService } from '../../core/services/profile.service';

@Component({
    selector: 'app-facilities',
    templateUrl: './facilities.component.html',
    styleUrls: ['./facilities.component.scss'],
    standalone: false
})
export class FacilitiesComponent {

    public pageStore$: BehaviorSubject<any>;

    constructor(
        logger: LoggerService,
        public profile: ProfileService,
        changeDetector: ChangeDetectorRef
    ) {
        this.pageStore$ = this.profile.profile$.pipe(
            filter((profile) => !!profile),
            map((profile) => this.profile.pageStore)
        ) as BehaviorSubject<any>;
    }
}
